/**
 * 毛坯房精装-图片控制
 * @returns
 */
import {
  Flex,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  Text,
  Image,
} from "@chakra-ui/react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { RiCheckFill } from "@remixicon/react";
import { selectMode, updateDesign } from "@/reducer/modeslice";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const PictureControlModal = (props: Props) => {
  const { isOpen, onClose } = props;
  const dispatch = useAppDispatch();
  const { design } = useAppSelector(selectMode);

  const refStructure = design.refstructure[design.refstructure.length-1];

  const handleChangePicControlStrength = (value: number) => {
    let currentStructureImages = [...design.refstructure];
    currentStructureImages[0] = {
      ...currentStructureImages[0],
      weight: value/100,
    };
    const newdesign = { ...design, refstructure: currentStructureImages };
    dispatch(updateDesign(newdesign));
  };

  const handleChangePictureControl = (val: string) => {
    let currentStructureImages = [...design.refstructure];
    currentStructureImages[0] = {
      ...currentStructureImages[0],
      refStructureType: val,
    };
    const newdesign = { ...design, refstructure: currentStructureImages };
    dispatch(updateDesign(newdesign));

  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        w="457px"
        background="linear-gradient(237.85deg, #172248 9.18%, #161922 67.26%)"
      >
        <ModalHeader color="#27314D" fontSize={"18px"}></ModalHeader>
        <ModalCloseButton color={"#B9B9B9"} />
        <ModalBody pb={6}>
          <Box mt="10px">
            <Box
              background={
                refStructure.refStructureType === "lineart"
                  ? "linear-gradient(90deg, #66E8E0 0%, #496AE1 100%)"
                  : "#6C7596"
              }
              borderRadius="10px"
              p="1px"
              onClick={()=>handleChangePictureControl("lineart")}
            >
              <Box background="#0C0B10" p="15px" borderRadius="10px">
                <Flex alignItems={"center"} gap="20px">
                  <Box flex={1}>
                    <Box mb="12px" fontSize={"16px"} color="#FFFFFF">
                      景深控制：提取空间形状
                    </Box>
                    <Flex alignItems={"center"} gap="12px">
                      <Text fontSize={"14px"} color="#6C7596">
                        控制强度
                      </Text>
                      <Slider
                        flex={1}
                        value={refStructure.weight? Math.floor(refStructure.weight*100) : 50}
                        step={1}
                        min={1}
                        max={100}
                        onChange={handleChangePicControlStrength}
                      >
                        <SliderTrack bg="#6C7596" h="8px" borderRadius={"8px"}>
                          <SliderFilledTrack bg="linear-gradient(90deg, #66E8E0 0%, #496AE1 100%)" />
                        </SliderTrack>
                        <SliderThumb bg="#FFFFFF" boxSize={"18px"} />
                      </Slider>
                      <Text fontSize={"14px"} color="#FFFFFF">
                        {refStructure.weight? Math.floor(refStructure.weight*100) : 50}%
                      </Text>
                    </Flex>
                  </Box>
                  <Box w="24px" h="24px">
                    {refStructure.refStructureType === "lineart" && (
                      <RiCheckFill color="#FFFFFF" size={"24px"} />
                    )}
                  </Box>
                </Flex>
              </Box>
            </Box>

            <Box
              background={
                refStructure.refStructureType === "mlsd"
                  ? "linear-gradient(90deg, #66E8E0 0%, #496AE1 100%)"
                  : "#6C7596"
              }
              borderRadius="10px"
              p="1px"
              mt="15px"
              onClick={()=>handleChangePictureControl("mlsd")}
            >
              <Box background="#0C0B10" p="15px" borderRadius="10px">
                <Flex alignItems={"center"} gap="20px">
                  <Box flex={1}>
                    <Box fontSize={"16px"} color="#FFFFFF">
                      线条控制：提取图片线条轮廓后出图
                    </Box>
                  </Box>
                  <Box w="24px" h="24px">
                    {refStructure.refStructureType === "mlsd" && (
                      <RiCheckFill color="#FFFFFF" size={"24px"} />
                    )}
                  </Box>
                </Flex>
              </Box>
            </Box>

            {/* <Box
              background={
                refStructure.refStructureType === "重绘原图内容"
                  ? "linear-gradient(90deg, #66E8E0 0%, #496AE1 100%)"
                  : "#6C7596"
              }
              borderRadius="10px"
              p="1px"
              mt="15px"
              onClick={()=>handleChangePictureControl("重绘原图内容")}
            >
              <Box background="#0C0B10" p="15px" borderRadius="10px">
                <Flex alignItems={"center"} gap="20px">
                  <Box flex={1}>
                    <Box fontSize={"16px"} color="#FFFFFF">
                      重绘原图内容
                    </Box>
                  </Box>
                  <Box w="24px" h="24px">
                    {refStructure.refStructureType === "重绘原图内容" && (
                      <RiCheckFill color="#FFFFFF" size={"24px"} />
                    )}
                  </Box>
                </Flex>
              </Box>
            </Box> */}
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default PictureControlModal;
